/* eslint-disable */
import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import storeRoutes from './storeRoutes'

const persistConfig = {
  key: 'root',
  storage,
}
const persistedReducer = persistReducer(persistConfig, storeRoutes)
export const store = configureStore({
  reducer: persistedReducer,
  // Add middleware, enhancers, etc. as needed
})
export const persistor = persistStore(store)
